import React, { useState, useEffect } from 'react'
import data from './data'
import Article from './Article'

function App() {
  let getStorageTheme = () =>{
    let theme = 'light-theme';
    if(localStorage.getItem("theme")){
      theme = localStorage.getItem("theme")
    }
    return theme;
  }
  const [theme, setTheme] = useState(getStorageTheme());
  
  let handleClick = (e) =>{
    if(theme === "light-theme"){
      setTheme("dark-theme")
    }else{
      setTheme("light-theme")
    }
  }

  useEffect(() => {
    document.documentElement.className = theme;
    localStorage.setItem('theme', theme);
  }, [theme]);

  
  return <main>
    <nav>
      <div className="nav-center">
        <h1>overreacted</h1>
        <button className='btn' onClick={handleClick}>toggle</button>
      </div>
    </nav>
    <section className="articles">
      {data.map((item,index)=>{
        return <Article {...item} key={index} class="post"></Article>
      })}
    </section>
  </main>
}

export default App
